import { useQuery } from '@tanstack/react-query';
import { audienceService } from '@/services/audienceService';
export const useAudienceCatalog = (enabled = true) => useQuery({ queryKey: ['audience-catalog'], queryFn: audienceService.catalog, enabled });
